exports = module.exports = require("../../node_modules/._css-loader@0.28.4@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/submit text project/gwin/src/app/app.component.styl
// module id = ../../../../../src/app/app.component.styl
// module chunks = 3